import instance from "./BasebLeatApi";

export function validateLeatCredentials(data) {
    return instance.request({
      url: `validate-credentials/`,
      method: "POST",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    });
  }

export function updateLeatCredentials(data) {
  return instance.request({
    url: `update-credentials/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
  
  export function saveLeatMappings(data) {
    return instance.request({
      url: `save-mappings/`,
      method: "POST",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    });
  }
  
//   export function getAtreemoStatus(organisationId, locationId = null, brandId = null) {
//     return instance.request({
//       url: `status/?organisation_id=${organisationId}${locationId ? `&location_id=${locationId}` : ''}${brandId ? `&brand_id=${brandId}` : ''}`,
//       method: "GET",
//       withCredentials: false,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//     });
//   }
  
//   export function getAtreemoResources(organisationId) {
//     return instance.request({
//       url: `resources/?organisation_id=${organisationId}`,
//       method: "GET",
//       withCredentials: false,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//     });
//   }
  
  export function getLeatMappings(organisationId) {
    return instance.request({
      url: `mappings/?organisation_id=${organisationId}`,
      method: "GET",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  export function getLeatStatus(organisationId) {
    return instance.request({
      url: `status/?organisation_id=${organisationId}`,
      method: "GET",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  export function getLeatShops(organisationId) {
    return instance.request({
      url: `shops/?organisation_id=${organisationId}`,
      method: "GET",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  }

  export function deactivateLeat(data) {
    return instance.request({
      url: `deactivate/`,
      method: "POST",
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    });
  }

export function updateLeatVisitsSettings(data) {
  return instance.request({
    url: `visits-settings/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}

export function getLeatContactAttributes(organisationId) {
  return instance.request({
    url: `contact-attributes/?organisation_id=${organisationId}`,
    method: "GET",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
}

export function updateLeatFieldMappings(data) {
  return instance.request({
    url: `field-mappings/`,
    method: "POST",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data: data,
  });
}
  
//   export function deactivateAtreemo(data) {
//     return instance.request({
//       url: `deactivate/`,
//       method: "POST",
//       withCredentials: false,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//       data: data,
//     });
//   }
  